/** The Auth product ID for Data Mission Sync, used for plans, subscriptions and consultant hour packages. */
export const DATA_MISSION_PRODUCT_ID = 'data-mission';
